import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import {
    ProvisionOrganizationInputDto,
    ProvisionOrganizationOutputDto,
} from '../../../models/organization-provisioning/dto/provision-organization.dto';
import { MY_ORGANIZATIONS_QUERY_KEY } from '../../organization/hooks/useGetMyOrganizations';

/**
 * `POST organization-provisioning` — elevated admins only (the API
 * answers 403 to anyone else). Refreshes the org picker so the new club can be
 * selected straight away.
 */
export const useProvisionOrganization = () => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['provisionOrganization'],
        mutationFn: (body: ProvisionOrganizationInputDto) =>
            apiClient.fetchApi<ProvisionOrganizationOutputDto, ProvisionOrganizationInputDto>({
                method: 'POST',
                endpoint: 'organization-provisioning',
                body,
            }),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: MY_ORGANIZATIONS_QUERY_KEY }),
    });
};
